import { Label, ScrollablePane, Stack } from "@fluentui/react";
import React from "react";

export interface LabeledScrollableTextProps {
    label: string;
    value: string;
    width?: number | string;
    height?: number | string;
}

export const LabeledScrollableText: React.FunctionComponent<LabeledScrollableTextProps> = (
    props: LabeledScrollableTextProps
) => {
    return (
        <Stack styles={{ root: { marginBottom: 10 } }}>
            <Label>{props.label}</Label>
            <Stack styles={{ root: { height: props.height, position: "relative" } }}>
                <ScrollablePane styles={{ root: { width: props.width } }}>
                    <Stack>{props.value ?? "-"}</Stack>
                </ScrollablePane>
            </Stack>
        </Stack>
    );
};
LabeledScrollableText.defaultProps = {
    width: 300,
    height: 150
};
